<template>
    <div class="cdn-tabs" @click="clickParent">
      <!-- <div
       v-for="(items, index) in tabs"
       :key='index'
       :class="selectedTab === items ?
        'tabs-item selected' : 'tabs-item'">{{items}}</div>
    </div> -->
    <div
       v-for="(items, index) in tabs"
       :key='index'
       class="tabs-item selected">{{items}}</div>
    </div>
</template>

<script>
export default {
  props: {
    tabs: Array, // ['产品列表', '产品套餐']
  },
  mounted() {
    // this.$emit('tabClick', this.selectedTab);
  },
  methods: {
    clickParent(e) {
      const event = e || window.event;
      const target = event.target || event.srcElement;
      this.selectedTab = target.innerText;
      const len = target.children && target.children.length;
      if (len) {
        return;
      }
      this.$emit('tabClick', this.selectedTab);
    },
  },
  data() {
    return {
      selectedTab: this.tabs && this.tabs[0],
    };
  },

};
</script>
<style lang="scss" scoped>
  .cdn-tabs {
    display: flex;
    .tabs-item {
      white-space:nowrap;
      padding: 18px 27px;
      background-color: white;
      border-radius: 4px;
      margin-right: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
      cursor: pointer;
    }
    .selected {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1E5EFF;
    }
  }
</style>
